import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Provider } from 'react-redux'
import { store } from './store'
import { PublicAuthProvider } from './contexts/PublicAuthContext.jsx'
import { ThemeProvider } from './contexts/ThemeContext.jsx'

// Disable console logs in production only (web app)
if (import.meta.env.MODE === 'production') {
  console.log = () => {}
  console.warn = () => {}
  console.error = () => {}
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PublicAuthProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </PublicAuthProvider>
    </Provider>
  </StrictMode>,
)
